/**
 * Created by andrey on 01.07.2020
 */

const Terms = cc.Node.extend({
    ctor: function () {
        this._super();

        this.setAnchorPoint(0.5, 0.5);

        const terms = new cc.Node();
        terms.setAnchorPoint(0.5, 0.5);
        // eslint-disable-next-line no-restricted-syntax
        terms.addChild(cleverapps.UI.generateTTFText(Messages.get("Terms.TermsOfService"), cleverapps.styles.FONTS.TERMS_LINK_TEXT));
        cleverapps.UI.wrap(terms);
        this.addChild(terms);

        // eslint-disable-next-line no-restricted-syntax
        const and = cleverapps.UI.generateTTFText(` ${Messages.get("Terms.and")} `, cleverapps.styles.FONTS.TERMS_TEXT);
        this.addChild(and);

        const privacy = new cc.Node();
        privacy.setAnchorPoint(0.5, 0.5);
        // eslint-disable-next-line no-restricted-syntax
        privacy.addChild(cleverapps.UI.generateTTFText(Messages.get("Terms.PrivacyPolicy"), cleverapps.styles.FONTS.TERMS_LINK_TEXT));
        cleverapps.UI.wrap(privacy);
        this.addChild(privacy);

        cleverapps.UI.arrangeWithMargins(this.children, {
            direction: cleverapps.UI.HORIZONTAL,
            margin: cleverapps.styles.Terms.margin
        });
        cleverapps.UI.wrap(this);

        cleverapps.UI.applyHover(terms);
        cleverapps.UI.applyHover(privacy);

        const business = (connector.config[connector.info.source] || {}).business || connector.config.business;

        const termsConfig = connector.config.terms[business];
        const termsUrl = termsConfig.terms;
        const privacyUrl = termsConfig.privacy;

        cleverapps.UI.onClick(terms, () => {
            connector.platform.openUrl(termsUrl);
        });
        cleverapps.UI.onClick(privacy, () => {
            connector.platform.openUrl(privacyUrl);
        });
    }
});

cleverapps.overrideColors(cleverapps.styles.COLORS, {
    TERMS_LINK_COLOR: new cc.Color(97, 167, 221, 255),
    TERMS_TEXT_COLOR: new cc.Color(55, 80, 58, 255)
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    TERMS_TEXT: {
        size: 25,
        color: cleverapps.styles.COLORS.TERMS_TEXT_COLOR
    },

    TERMS_LINK_TEXT: {
        size: 25,
        color: cleverapps.styles.COLORS.TERMS_LINK_COLOR
    }
});

cleverapps.styles.Terms = {
    margin: 6
};